import React, { useMemo } from 'react';
import TrebbleSelect from '../../../../common/Select';
import { FontValue, FONT_OPTIONS, loadAllFonts } from '../../../remotion/types/fonts';

interface FontSelectProps {
    value: FontValue;
    onChange: (value: FontValue) => void;
    className?: string;
}

export type { FontValue };
export const FontSelect: React.FC<FontSelectProps> = ({ value, onChange, className = '' }) => {
    React.useEffect(() => {
        loadAllFonts();
    }, []);

    // Memoize the sorted font options
    const sortedFontOptions = useMemo(() => {
        return [...FONT_OPTIONS].sort((a, b) => a.label.localeCompare(b.label));
    }, []);

    return (
        <TrebbleSelect
            value={value}
            onChange={onChange}
            className={className}
            options={sortedFontOptions}
            optionLabelProp="label"
            useEditorTheme
            optionRender={(option) => (
                <span style={{ fontFamily: option.data.fontFamily }}>
                    {option.data.label}
                </span>
            )}
            labelRender={(option) => (
                <span style={{ fontFamily: sortedFontOptions.find(f => f.value === option.value)?.fontFamily }}>
                    {option.label}
                </span>
            )}
        />
    );
};
